import type { ExtractValues } from '../helpers';
import { Joi, objectSchemaOf, actionCreator } from '../helpers';
import { DIALOGUE_INPUT } from './topics';

export const interactionModes = ['touch', 'voice'] as const;

export type InteractionMode = ExtractValues<typeof interactionModes>;

export const interactionModeSchema = Joi.string()
  .allow(...interactionModes)
  .required();

export const INTERACTION_MODE = 'DIALOGUE/INTERACTION_MODE';

export interface IInteractionModePayload {
  conversationId: string;
  mode: InteractionMode;
  description: string;
}

export const interactionModePayloadSchema = objectSchemaOf<IInteractionModePayload>(
  {
    conversationId: Joi.string().required(),
    mode: interactionModeSchema,
    description: Joi.string().required(),
  }
);

export interface IInteractionModeAction {
  type: typeof INTERACTION_MODE;
  payload: IInteractionModePayload;
}

export const interactionModeActionSchema = objectSchemaOf<IInteractionModeAction>(
  {
    type: Joi.string().valid(INTERACTION_MODE).required(),
    payload: interactionModePayloadSchema.required(),
  }
);

export const interactionMode = actionCreator({
  schema: interactionModeActionSchema,
  topic: DIALOGUE_INPUT,
  type: INTERACTION_MODE,
});
